<script lang="tsx" name="form-base-table-expand-render">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
    scope: {
      type: Object,
      default: () => ({}),
    },
    isVirtuallyTable: {
      type: Boolean,
      default: false,
    },
  },
  render() {
    if (this.isVirtuallyTable && this.row.showOverflow) {
      return (
        <el-tooltip
          content={
            this.scope.row[this.row.prop]
              ? this.scope.row[this.row.prop].toString()
              : ''
          }
          placement="top"
        >
          <span>{this.row.expand(this.scope.row)}</span>
        </el-tooltip>
      )
    } else {
      return this.row.expand(this.scope.row)
    }
  },
})
</script>
